<template>
  <div class="pb-2 section">
    <div class="container">
      <div class="container__inner px-1.5">
        <p class="p-0 py-2 m-0 text-xl lg:text-4xl lg:pb-2" id="quiz_block">
          {{ question.title }}
        </p>

        <div
          v-if="question.description"
          class="pb-2"
          v-html="question.description"
        ></div>

        <div v-if="question.media" class="pb-2">
          <img :src="question.media.guid" />
        </div>

        <form name="quiz-form" class="quiz-form" method="post">
          <div
            class="grid gap-1 lg:gap-2 md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-3"
          >
            <div
              v-for="(choice, idx) in question.answers"
              :key="choice.id"
              class="question-item bg-dark p-1.5 pb-4 rounded-2xl text-white text-base lg:text-lg leading-normal relative"
            >
              <input
                :checked="choices.includes(choice.id)"
                @change="change(choice.id)"
                :value="choice.id"
                type="radio"
                :name="'choice'"
                :id="'choice-' + choice.id"
              />
              <div
                class="flex items-center justify-center w-3 h-3 mb-2 text-sm question-item__rank"
              >
                {{ idx + 1 }}
              </div>
              <label :for="'choice-' + choice.id" class="break-words">
                <CheckIcon
                  class="inline w-1 h-1"
                  v-if="isDev && choice.valid"
                />
                <span v-html="choice.title"></span>
              </label>
            </div>
            <!-- .question-item -->
          </div>
          <!-- .grid -->

          <div class="py-2 lg:py-4">
            <button
              id="next_question"
              type="button"
              class="bt"
              :disabled="choices.length === 0"
              @click="$emit('nextQuestion')"
            >
              <span>Question suivante</span>
            </button>
          </div>
        </form>
      </div>
      <!-- .container__inner -->
    </div>
    <!-- .container -->
  </div>
  <!-- .section -->
</template>
<script setup>
import { ref } from "vue";
import CheckIcon from "./icons/CheckIcon.vue";
const props = defineProps({
  question: {
    type: Object,
    required: true,
  },
  modelValue: {
    type: Array,
    required: true,
  },
  answer: {},
});
const isDev = document.location.hostname.match(/(localhost|monudi.test)/);
const emit = defineEmits(["update:modelValue", "nextQuestion"]);
const choices = ref(props.modelValue);
const change = (id) => {
  choices.value = [id];
  emit("update:modelValue", choices.value);
};
</script>
